import React from 'react';
import * as yup from 'yup';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { tabelaPrecoAdesaoTodas, tabelaPrecoPromocao } from './promocaoCidade';
import { ProgressSpinner } from 'primereact/progressspinner';
import { decriptObjectOnLocalStorage } from '../cripotografia/criptoStorage';

const dataDeAmanha = new Date(new Date().setDate(new Date().getDate() + 1));

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    },
    stepper: {
        padding: theme.spacing(3, 0, 3),
        display: 'flex',
        justifyContent: 'flex-start'
    },

    label: {
        fontSize: '15px',
        color: '#000000',
        margin: '0 4px'
    },
    input: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    Autocomplete: {
        marginTop: '10px',
        width: '50%'
    },
    buttons: {
        marginTop: '15px'
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '15px'
    },
    buttonDelete: {
        marginTop: '15px',
        marginLeft: '2rem'
    },
    msgInfoBotaoDelete: {
        width: '18vw',
        color: 'red',
        marginLeft: '1rem',
        marginTop: '10px'
    },
    button: {
        height: '3rem',
        marginRight: '1rem',
        fontSize: '12px'
    },
    buttonSearch: {
        height: '3rem',
        width: '12rem',
        marginRight: '0.8rem',
        marginBottom: '0.4rem'
    },
    buttonSair: {
        marginTop: '15px',
        marginLeft: '2rem'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 247
    },
    formControl: {
        display: 'flex',
        flexDirection: 'row'
    },
    inputPorcentagem: {
        width: '50px',
        height: '25px',
        marginTop: '5px'
    }
}));

export const validations = yup.object().shape({
    macroReg: yup.string(),

    carenciaSemPro: yup
        .string()
        .required('Carência s/ Promoção é um campo obrigatorio!'),

    Novo: yup.string().required('Total(Novo) é um campo obrigatorio!'),

    Troca: yup
        .string()
        .required('Troca é um campo obrigatorio!'),

    Reab: yup
        .string()
        .required('Reabilitação é um campo obrigatorio!'),

    Plano: yup
        .string()
        .required('Plano é um campo obrigatorio!'),

    desconto: yup
        .number()
        .min(0, 'Deve ser um número positivo')
        .max(99, 'Até dois dígitos')

});

export const validationsBonificacao = yup.object().shape({
    descricao: yup
        .string()
        .required('Descrição é um campo obrigatório!')
        .max(100, 'A descrição deve ter no máximo 100 caracteres'),

    dataInicioVigencia: yup
        .date()
        .when('$bloquearInputs', {
            is: false,
            then: yup.date()
                .required('Data de início de vigência é um campo obrigatório!')
                .min(new Date(), 'A data de início de vigência não pode ser retroativa.'),
            otherwise: yup.date().notRequired()
        }),

    dataFinalVigencia: yup
        .date()
        .required('Data final de vigência é um campo obrigatório!')
        .min(yup.ref('dataInicioVigencia'), 'A data final de vigência deve ser posterior à data de início.'),

    selectedMonths: yup
        .array()
        .min(1, 'Selecione pelo menos um mês para a bonificação'),

    status: yup
        .boolean()
        .required('Início Abono é um campo obrigatório!'),

    valorDesconto: yup
        .number()
        .nullable()
        .when('aplicarDesconto', {
            is: true,
            then: yup
                .number()
                .required('O valor do desconto é obrigatório.'),
            otherwise: yup.number().notRequired()
        })
});

export const validationsEditarAdesao = yup.object().shape({
    desconto: yup
        .number()
        .min(0, 'Deve ser um número positivo')
        .max(99, 'Até dois dígitos')
});

yup.addMethod(yup.string, 'descontoIgualValorBase', function (errorMessage) {
    return this.test('test-desconto-igual-valor-base', errorMessage, function (_value) {
        const { path, createError, parent } = this;
        let temErro = false;
        const { valorBase, valorDesconto } = parent;

        const parseValorBase = Number.parseFloat(valorBase);
        const parseValorDesconto = Number.parseFloat(valorDesconto);

        if (parseValorBase === parseValorDesconto) {
            temErro = true;
        }

        return (
            !temErro ||
            createError({
                path,
                message: errorMessage
            })
        );
    });
});

yup.addMethod(yup.string, 'valorBaseNaoPodeSerZero', function (errorMessage) {
    return this.test('test-valorBase-nao-pode-ser-zero', errorMessage, function (_value) {
        const { path, createError, parent } = this;
        let temErro = false;
        const { Valor_base, Plano } = parent;
        const parseValorBase = Number.parseFloat(Valor_base);

        if (parseValorBase === 0 && Plano?.trim() !== 'ZTA') {
            temErro = true;
        }

        return (
            !temErro ||
            createError({
                path,
                message: errorMessage
            })
        );
    });
});

export const validationsMensalidade = yup.object().shape({

    macroReg: yup.string(),

    Valor_base: yup
        .string()
        .when('Plano', {
            is: Plano => Plano?.trim() === 'ZTA',
            then: yup.string(),
            otherwise: yup.string()
                .required('Valor base é um campo obrigatorio!')
                .valorBaseNaoPodeSerZero('Valor Base nao pode ser igual a zero')
        }),

    valorDesconto: yup.string().nullable().descontoIgualValorBase('O valor do desconto não pode ser igual ao valor base')
        .test(
            '',
            'O campo Valor do desconto não pode ter um valor maior que o valor base!',
            function (valorDesconto) {
                const { Valor_base } = this.parent;

                if (Valor_base === undefined || valorDesconto === undefined) {
                    return true;
                } else {
                    const valorBaseFloat = parseFloat(Valor_base.replace(',', '.'));
                    const valorDescontoFloat = parseFloat(valorDesconto.replace(',', '.'));

                    if (valorDescontoFloat < valorBaseFloat) {
                        return true;
                    }

                    return false;
                }
            }
        ),

    Plano: yup
        .string()
        .required('Plano é um campo obrigatorio!'),

    dataInicioDesconto: yup.date().nullable()
        .when(
            'valorDesconto', {
            is: valorDesconto => valorDesconto,
            then: yup.date().required('Preencha uma data para início do desconto.'),
            otherwise: yup.date()
        }
        ).min(dataDeAmanha, 'A data de início não pode ser inferior a data de amanhã!'),
    dataFinalDesconto: yup.date('insira uma data valida').nullable()
        .min(
            yup.ref('dataInicioDesconto'), 'A data final de desconto deve ser maior que a data inicial do desconto!'

        ).min(new Date(), 'A data final de desconto não pode ser inferior a data atual!')
        .when('dataInicioDesconto', {
            is: true,
            then: yup.date().required('Caso a data de início esteja informada, data final deve ser preenchida!'),
            otherwise: yup.date()
        }),
    pagamentoCartao: yup.boolean(),
    pagamentoBoleto: yup.boolean(),
    pagamentoEscelsa: yup.boolean(),
    formasPagamento: yup.lazy(value =>
        yup.boolean().test(
            'pelo-menos-uma-forma-pagamento',
            'Selecione pelo menos uma forma de pagamento',
            function (value) {
                const { valorDesconto, pagamentoCartao, pagamentoBoleto, pagamentoEscelsa } = this.parent;

                if (valorDesconto?.length > 0) {
                    return pagamentoCartao || pagamentoBoleto || pagamentoEscelsa;
                }

                return true;
            }
        )
    )
});

export const initialValues = {
    uf: '',
    cidade: '',
    macroReg: '',
    carenciaSemPro: '',
    Novo: '',
    Troca: '',
    Reab: '',
    Crem: '',
    Plano: '',
    dataInsert: '',
    dataUpdate: '',
    userCreated: '',
    userUpdated: '',
    Valor_base: '',
    desconto: '',
    valorDesconto: '',
    dataInicioDesconto: '',
    dataFinalDesconto: '',
    pagamentoCartao: false,
    pagamentoBoleto: false,
    pagamentoEscelsa: false,
    formasPagamento: ''
};

export const initialValuesBonificacao = {
    descricao: '',
    dataInicioVigencia: '',
    dataFinalVigencia: '',
    parcelaBonificacao: '',
    tipoCobranca: '',
    status: '',
    userCreated: decriptObjectOnLocalStorage('IDuser'),
    pagamentoCartao: false,
    pagamentoBoleto: false,
    aplicarDesconto: false,
    valorDesconto: null,
    bonificacao: true
};

export const mesDoAno = {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
    12: false
};

export const initialValuesEdit = {
    carencia: '',
    adesao_novo: '',
    adesao_troca: '',
    adesao_reab: '',
    adesao_cremacao: '',
    dataUpdate: '',
    userUpdated: '',
    valorBase: '',
    valorDesconto: '',
    dataInicioDesconto: '',
    dataFinalDesconto: '',
    pagamentoCartao: false,
    pagamentoBoleto: false,
    pagamentoEscelsa: false,
    formasPagamento: ''
};

export function ProdutoDescricaoBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Plano</span>
                <span className="p-column-value">{rowData?.Produto?.descricao}</span>
            </div>
        </React.Fragment>
    );
}

export function ProdutoDescricaoSubGrupo(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Subgrupo</span>
                <span className="p-column-value">{rowData.subgrupo}</span>
            </div>

        </React.Fragment>
    );
}

export function CidadeBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Cidade</span>
                <span className="p-column-value">{rowData.CidadesIBGE.NOME}</span>
            </div>
        </React.Fragment>
    );
}

export function MacroRegiao(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Macro Regiao</span>
                <span className="p-column-value">{rowData.macro_regiao}</span>
            </div>
        </React.Fragment>
    );
}

export function Estado(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Estado</span>
                <span className="p-column-value">{rowData.UF}</span>
            </div>

        </React.Fragment>
    );
}

export function valorBase(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Valor Base</span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.valorBase)}
                </span>
            </div>
        </React.Fragment>
    );
}

export function ValorMensalidade(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Valor</span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.Produto.valor)}
                </span>
            </div>
        </React.Fragment>
    );
}

export function valorComDescontoCartao(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Cartão</span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.descontoCartao?.valor ?? 0)}
                </span>
            </div>
            {rowData.descontoCartao?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    <span className="p-column-value">
                        {`${String(new Date(rowData.descontoCartao.vigenciaInicio).toLocaleDateString('pt-BR'))} até
                        ${String(new Date(rowData.descontoCartao.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                    </span>
                </div> :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export function valorComDescontoBoleto(rowData) {
    return (
        <React.Fragment>

            <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Boleto</span>
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.descontoBoleto?.valor ?? 0)}
            </div>
            {rowData.descontoBoleto?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    <span className="p-column-value">
                        {`${String(new Date(rowData.descontoBoleto.vigenciaInicio).toLocaleDateString('pt-BR'))} até
                        ${String(new Date(rowData.descontoBoleto.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                    </span>
                </div> :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export function valorComDescontoEscelsa(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Escelsa</span>
                <span className="p-column-value">
                    {rowData.UF === 'ES' ? new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.descontoEscelsa?.valor ?? 0) : 'Não se aplica'}
                </span>
            </div>

            {rowData.descontoEscelsa?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    <span className="p-column-value">
                        {`${String(new Date(rowData.descontoEscelsa.vigenciaInicio).toLocaleDateString('pt-BR'))} até
                    ${String(new Date(rowData.descontoEscelsa.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                    </span>
                </div> :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export function CarenciaPromocionalBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Carência Promoção</span>
            <span className="p-column-value">{`${rowData.carencia_promocional} dias`}</span>
        </React.Fragment>
    );
}

export function CarenciaBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Carência s/ Promoção</span>
                <span className="p-column-value">{`${rowData.carencia} dias`}</span>
            </div>
        </React.Fragment>
    );
}

export function NovoBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Novo </span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.adesao_novo)}
                </span>
            </div>
        </React.Fragment>
    );
}

export function DescontoBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Desconto </span>
                <span className="p-column-value">{rowData.percentualDesconto ? `${rowData.percentualDesconto}`.replace('.', ',') : 0} %</span>
            </div>
        </React.Fragment>
    );
}

export function TrocaBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Troca</span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.adesao_troca)}
                </span>
            </div>
        </React.Fragment>
    );
}

export function ReabBody(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title"> Reabilitação </span>
                <span className="p-column-value">
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(rowData.adesao_reab)}
                </span>
            </div>
        </React.Fragment>
    );
}

export function CremaçãoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title"> Cremação </span>
            <span className="p-column-value">
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.adesao_cremacao)}
            </span>
        </React.Fragment>
    );
}

export function UpdateBody(rowData) {
    return (
        <React.Fragment>
            <div className="datatable-body">
                <span className="p-column-title"> Editado por </span>
                {rowData?.userAccessCreated?.AnalistaComercial?.userCreated && <span className="p-column-value">
                    {rowData?.userAccessCreated?.AnalistaComercial?.userCreated} em {moment(rowData.dataUpdate)
                        .add(3, 'hours')
                        .format('DD/MM/YYYY [às] HH:mm')}
                </span>}
            </div>
        </React.Fragment>
    );
}

export const inicioVigenciaBodyTemplate = rowData => (
    <React.Fragment>
        {moment.utc(rowData.dataInicioVigencia).format('DD/MM/YYYY')}
    </React.Fragment>
);

export const finalVigenciaBodyTemplate = rowData => (
    <React.Fragment>
        {moment.utc(rowData.dataFinalVigencia).format('DD/MM/YYYY')}
    </React.Fragment>
);

export const dataInativacaoBodyTemplate = rowData => (
    <React.Fragment>
        {rowData.dataInativacao ? moment.utc(rowData.dataInativacao).format('DD/MM/YYYY') : 'Sem Data'}
    </React.Fragment>
);

export const tipoCobrancaTemplate = rowData => {
    const tipoCobrancaMap = {
        1: 'Boleto',
        7: 'Cartão'
    };

    if (Array.isArray(rowData.tiposCobrancaIds)) {
        const tipos = rowData.tiposCobrancaIds.map(tipo => tipoCobrancaMap[tipo]).join(', ');

        return (
            <React.Fragment>
                <span>{tipos}</span>
            </React.Fragment>
        );
    }

    return null;
};

export const statusBodyTemplate = rowData => (
    <React.Fragment>
        <span style={{ color: rowData.status ? 'green' : 'red' }}>
            {rowData.status ? 'Ativo' : 'Inativo'}
        </span>
    </React.Fragment>
);

export async function BuscaCidadeCodigo(codigoCidade, setGetPromocao, plano) {
    const resultCidades = await tabelaPrecoPromocao(true, 'cidade', codigoCidade, plano);

    setGetPromocao(resultCidades);
}

export async function BuscaEstadoCodigo(codigoEstado, setGetPromocao, plano) {
    const resultCidades = await tabelaPrecoPromocao(true, 'UF', codigoEstado, plano);

    setGetPromocao(resultCidades);
}

export async function BuscaTabela(setGetPromocao) {
    const resultCidades = await tabelaPrecoAdesaoTodas(true);

    setGetPromocao(resultCidades);
}

export const calculaValorComDesconto = values => {
    const { desconto, adesao_novo } = values || {};

    const percentualDesconto = desconto ? Number(`${desconto}`.replace('%', '')) / 100 : 0;

    const valorAdesaoNovo = adesao_novo && Number(`${adesao_novo}`.replace('R', '').replace('$', '').replace(',', '.'));

    const total = valorAdesaoNovo && (valorAdesaoNovo - (valorAdesaoNovo * percentualDesconto));

    const totalAux = total && `${total}`.replace('.', ',');

    if (totalAux && totalAux !== values.valorComDesconto) {
        values.valorComDesconto = total;
    }
};

export const calculaValorComDescontoAdicionarAdesao = values => {
    const { desconto, Novo } = values || {};

    const percentualDesconto = desconto ? Number(`${desconto}`.replace('%', '')) / 100 : 0;

    const valorAdesaoNovo = Novo && Number(`${Novo}`.replace('R', '').replace('$', '').replace(',', '.'));

    const total = valorAdesaoNovo && (valorAdesaoNovo - (valorAdesaoNovo * percentualDesconto));

    const totalAux = total && `${total}`.replace('.', ',');

    if (totalAux && totalAux !== values.valorComDesconto) {
        values.valorComDesconto = total;
    }
};

export const LoadingComponent = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexGrow: '1'
    }}>
        <ProgressSpinner animationDuration="1s" style={{
            width: '30%',
            height: '30%'
        }} />
    </div>
);
